import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAppSelector } from "../app/hooks"
import { ApplicationModel } from '../interfaces';

export default function Logo(props: any) {
    const currentUser = useAppSelector(store => store.currentUser);
    const client: ApplicationModel | null = currentUser?.userApplication;

    return (
            <React.Fragment>
                <Box {...props} id="logo-container">
                    <Box component='img' id="logo-img" src={client?.logoUri ?? '/lp-logo.png'} mb={1} maxWidth={220} maxHeight={50} />
                    <Typography variant='subtitle2' color="text.secondary" id="logo-text">
                        Logistics Plus® {client?.description ?? 'Universal Customer Portal'}
                    </Typography>
                </Box>
            </React.Fragment>
    );
}
